package app.api

import app.client
import app.model.ProjectWithDependencies
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import kotlinx.coroutines.Job

class ProjectApi : RootStore<ProjectWithDependencies?>(null, job = Job()) {
    val handler = handle { _, id: String ->
        val projectId = id.toInt()
        client.get(Routing.Projects.Dependencies.Id(id = projectId)).body<ProjectWithDependencies>()
    }
}
